import { atom } from 'jotai';

interface ISizesContentTypeAtom {
  sizes: string;
  contentType: string;
  path: string;
}

interface ISizesComponentNameAtom extends ISizesContentTypeAtom {
  componentName: string;
}

export const showGenesysAtom = atom(false);

export const sizesContentTypeAtom = atom<ISizesContentTypeAtom>({
  sizes: '',
  contentType: '',
  path: '',
});

export const sizesComponentNameAtom = atom<ISizesComponentNameAtom>({
  sizes: '',
  contentType: '',
  path: '',
  componentName: '',
});

// // new atom
// export const sizesComponentNameAtom = atom({
//   componentName: '',
// });

// // read combined atom
// export const sizesContentTypeAndComponentNameAtom = atom((get) => {
//   const contentType = get(sizesContentTypeAtom);
//   const componentName = get(sizesComponentNameAtom);

//   return {
//     ...contentType,
//     ...componentName
//   };
// });

// interface INewProps {
//   componentName: string;
// }

// // write new atom
// export const updateSizesComponentNameAtom = atom(
//   null,
//   (get, set, newProps: INewProps) => {
//     set(sizesComponentNameAtom, newProps);
//   }
// );
